import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { isEqual, isEmpty } from 'lodash'
import { Grid, Button, Collapse, Badge, IconButton } from '@material-ui/core'
import moment from 'moment'
import cn from 'classnames'
import SelectList from 'components/common/SelectList'
import {
  openEventFormModal,
  fetchEventFormList,
  fetchEventDataList,
  setPsfs,
  clearLogBookStore,
  resetEventsData,
  setDataFields,
  setLoadTableData,
  resetTableData,
  fetchLocusGroupsList,
} from 'reducers/logbook/reducer'
import { fetchActiveSitesWithoutSiteType } from 'reducers/digitalLogbook/reducer'
import {
  setSiteContext,
  updateProfileLogbookFilters,
  fetchProfile,
} from 'reducers/profile/reducer'
import {
  fetchRegionList,
  clearMnaStore,
  fetchSiteTypes,
  resetData,
  resetSitesData,
} from 'reducers/monitorsAndAlerts/reducer'
import { locusFetchList } from 'reducers/locus/reducer'
import { siteFetchList } from 'reducers/site/reducer'
import { setActiveDateRange } from 'reducers/sensor/reducer'
import Psfs from 'lib/psfs/Psfs'
import { FilterComponent } from 'routes/App/Apps/MonitorsAndAlerts/SiteFilters/FilterComponent'
import DateRangeInput from 'components/common/Form/DateRange'
import { LOOGBOOK_ALL_TYPES } from 'constants/requestTypes'
import { LOGBOOK } from 'constants/exportTypes'
import {
  COMPULSORY_FIELDS,
  LOGBOOK_FILTERS,
  PROFILE_LOGBOOK_FILTERS,
} from 'constants/logbookFilters'
import withPromise from 'helpers/withPromise'
import Pagination from 'lib/psfs/Pagination'
import CircleLoader from 'components/Loading/CircleLoader'
import { ReactComponent as OpenFiltersIcon } from 'assets/img/open-filters.svg'
import { ReactComponent as ClearFiltersIcon } from 'assets/img/clear-filters.svg'
import ExportButton from 'components/common/ExportButton'
import { getDateFormat } from 'helpers/dates'
import SearchBlock from './SearchBlock'
import logbookMessages from '../translate'
import messages from './translate'

class FilterBar extends Component {
  state = {
    dataLoaded: {},
    filtersArr: LOGBOOK_FILTERS,
    isFiltersOpen: false,
    siteFiltersToShow: [],
    eventFiltersToShow: [],
    showBadge: false,
    setInitialData: false,
    initialSiteLoaded: false,
    initialSite: null,
    componentLoaded: false,
    firstLoad: true,
    profileLogbookFilters: PROFILE_LOGBOOK_FILTERS,
    isDataLoading: false,
  }

  componentDidMount() {
    const {
      fetchSiteTypes,
      fetchRegionList,
      fetchEventFormList,
      activeSite,
      logbookFilters,
      setPsfs,
      location,
      intl: { formatMessage },
    } = this.props
    const updatedDataFields = this.addTranslationsToDataFields(formatMessage)

    fetchSiteTypes()
    fetchRegionList()

    if (activeSite) {
      fetchEventFormList({
        type: LOOGBOOK_ALL_TYPES,
        site: activeSite,
      })
    }

    this.fetchLocusList()
    this.fetchLocusGroups()
    this.setState({
      componentLoaded: true,
      profileLogbookFilters: logbookFilters,
      filtersArr: updatedDataFields,
    })

    setPsfs(new Psfs(location.pathname))
  }

  // eslint-disable-next-line max-statements
  componentDidUpdate(prevProps, prevState) {
    const {
      siteList,
      regions,
      siteTypes,
      activeSite,
      locusList,
      locusGroup,
      events,
      tableData,
      categories,
      fetchEventFormList,
      activeDateRange,
      fetchSiteTypes,
      fetchRegionList,
      resetData,
      resetEventsData,
      setSiteContext,
      updateProfileLogbookFilters,
      fetchEventDataList,
      resetSitesData,
      storeDataFields,
      dataFields,
      handleFieldsChange,
      setDataFields,
      dataLoader,
      isLoadTable,
      setLoadTableData,
      resetTableData,
      licensee: { name },
      logbookFilters: { dataFields: profileDataFields },
    } = this.props
    const {
      locusGroup: prevLocusGroup,
      regions: prevRegions,
      siteTypes: prevSiteTypes,
      activeSite: prevActiveSite,
      locusList: prevLocusList,
      siteList: prevSiteList,
      events: prevEvents,
      categories: prevCategories,
      activeDateRange: prevActiveDateRange,
      licensee: { name: prevName },
    } = prevProps
    const arrLocusGroup = locusGroup.toArray()
    const prevArrLocusGroup = prevLocusGroup.toArray()
    const arrSiteList = siteList.toArray()
    const prevArrSiteList = prevSiteList.toArray()
    const arrRegions = regions.toArray()
    const prevArrRegions = prevRegions.toArray()
    const arrSiteTypes = siteTypes.toArray()
    const prevArrSiteTypes = prevSiteTypes.toArray()
    const arrLocusList = locusList.toArray()
    const prevArrLocusList = prevLocusList.toArray()
    const arrEvents = events.toArray()
    const prevArrEvents = prevEvents.toArray()
    const arrCategories = categories.toArray()
    const prevArrCategories = prevCategories.toArray()
    const { startDate, endDate } = activeDateRange.toJS()
    const {
      startDate: prevStartDate,
      endDate: prevEndDate,
    } = prevActiveDateRange.toJS()
    const { dataLoaded, filtersArr, isLoading } = this.state
    const dataLoadedLength = Object.keys(dataLoaded).length
    const objStorePsfs = this.props.storePsfs
    const prevObjStorePsfs = prevProps.storePsfs
    const arrStoreDataFields = storeDataFields.toJS()

    const sitesData = filtersArr.filter(item => item.filterType === 'site')
    const eventData = filtersArr.filter(
      item =>
        item.filterType === 'event' &&
        item.storeName !== 'dataFields' &&
        item.storeName !== 'locusGroups',
    )

    const { value: dataFieldsState } = filtersArr.find(
      item => item.storeName === 'dataFields',
    )
    const { value: prevDataFieldsState } = prevState.filtersArr.find(
      item => item.storeName === 'dataFields',
    )
    const checkLoadedEventData = eventData.every(
      item => dataLoaded[item.storeName],
    )
    const checkLoadedSiteData = sitesData.every(
      item => dataLoaded[item.storeName],
    )
    const checkDataFields = dataFields.length ? dataFields : arrStoreDataFields
    const checkProfileDataFields = checkDataFields.length
      ? checkDataFields
      : profileDataFields

    if (
      (!isEqual(arrSiteList, prevArrSiteList) &&
        !isEqual(filtersArr, prevState.filtersArr)) ||
      activeSite !== prevActiveSite ||
      prevName !== name
    ) {
      setDataFields(dataFieldsState)
      this.setState(
        {
          isDataLoading: true,
          profileLogbookFilters: PROFILE_LOGBOOK_FILTERS,
          siteFiltersToShow: [],
          eventFiltersToShow: [],
          dataLoaded: {},
        },
        () => {
          withPromise(updateProfileLogbookFilters, {
            logbook_filters: {
              ...PROFILE_LOGBOOK_FILTERS,
            },
          }).then(data => {
            resetData()
            resetEventsData()

            if (prevName !== name) {
              const updatedArr = [...LOGBOOK_FILTERS].map(item => {
                if (item.storeName === 'dataFields') {
                  return {
                    ...item,
                    value: [],
                  }
                }

                return item
              })

              resetSitesData()
              fetchSiteTypes()
              fetchRegionList()
              this.setState({
                licenseeChanged: true,
                setInitialData: false,
                filtersArr: updatedArr,
              })
              handleFieldsChange([])
              setDataFields([])
            }

            this.fetchLocusList()
            this.fetchLocusGroups()

            if (activeSite) {
              fetchEventFormList({
                type: LOOGBOOK_ALL_TYPES,
                site: activeSite,
              })
            } else {
              resetTableData()
            }

            this.setState({
              isDataLoading: false,
              profileLogbookFilters: data.logbookFilters,
            })
          })
        },
      )
    }

    let initalSiteData

    if (!prevProps.tableData.get('count') && tableData.get('count') > 0) {
      this.setState({ firstLoad: false })
    }

    if (!isEmpty(this.state.siteFiltersToShow)) {
      initalSiteData = this.state.initialData.filter(
        item => item.filterType === 'site',
      )
    }

    if (
      !isEqual(arrSiteList, prevArrSiteList) &&
      arrSiteList.length > 0 &&
      this.state.componentLoaded &&
      !this.state.initialSite &&
      !activeSite
    ) {
      setSiteContext({ site: arrSiteList[0].id })
      this.setState({ initialSite: arrSiteList[0].id })
    }

    if (!isEqual(arrSiteList, prevArrSiteList) && arrSiteList.length > 0) {
      if (
        (!activeSite ||
          activeSite !== prevActiveSite ||
          activeSite !== arrSiteList[0].id) &&
        (this.state.setInitialData ||
          !isEqual(sitesData, initalSiteData) ||
          this.state.licenseeChanged)
      ) {
        setSiteContext({ site: arrSiteList[0].id })
        this.setState({ licenseeChanged: false })
      }
    }

    if (
      !isEqual(sitesData, initalSiteData) &&
      !isEqual(arrSiteList, prevArrSiteList) &&
      arrSiteList.length > 0 &&
      activeSite !== arrSiteList[0].id
    ) {
      setSiteContext({ site: arrSiteList[0].id })
    }

    if (!isEqual(arrRegions, prevArrRegions)) {
      const newArr = this.changeByProp('regions', arrRegions)
      const updatedArr = this.applyDataFromProfileFilters('regions', newArr)
      this.setFilterData('regions', updatedArr)
    }

    if (!isEqual(arrSiteTypes, prevArrSiteTypes)) {
      const newArr = this.changeByProp('siteTypes', arrSiteTypes)
      const updatedArr = this.applyDataFromProfileFilters('siteTypes', newArr)
      this.setFilterData('siteTypes', updatedArr)
    }

    if (!isEqual(arrEvents, prevArrEvents) && !prevArrEvents.length) {
      const newArr = this.changeByProp('events', arrEvents)
      const updatedArr = this.applyDataFromProfileFilters('events', newArr)
      this.setFilterData('events', updatedArr)
    }

    if (
      !isEqual(arrCategories, prevArrCategories) &&
      !prevArrCategories.length
    ) {
      const newArr = this.changeByProp('eventCategories', arrCategories)
      const updatedArr = this.applyDataFromProfileFilters(
        'eventCategories',
        newArr,
      )
      this.setFilterData('eventCategories', updatedArr)
    }

    if (
      dataLoadedLength > 0 &&
      checkLoadedSiteData &&
      isEmpty(this.state.siteFiltersToShow)
    ) {
      const data = this.getFiltersData('site')
      this.fetchDataByFilter(data, 'site')
      this.setState({ checkLoadedSiteData })
    }

    if (
      dataLoadedLength > 0 &&
      checkLoadedEventData &&
      isEmpty(this.state.eventFiltersToShow)
    ) {
      const data = this.getFiltersData('event')
      this.fetchDataByFilter(data, 'event')
    }

    if (!isEqual(arrLocusList, prevArrLocusList) && !prevArrLocusList.length) {
      const newArr = this.changeByProp('locuses', arrLocusList)
      const updatedArr = this.applyDataFromProfileFilters('locuses', newArr)
      this.setFilterData('locuses', updatedArr)
    }

    if (
      !isEqual(arrLocusGroup, prevArrLocusGroup) &&
      !prevArrLocusGroup.length
    ) {
      const newArr = this.changeByProp('locusGroups', arrLocusGroup)
      const updatedArr = this.applyDataFromProfileFilters('locusGroups', newArr)
      this.setFilterData('locusGroups', updatedArr)
    }

    if (
      (!isEqual(prevDataFieldsState, dataFieldsState) ||
        !isEqual(checkProfileDataFields, dataFieldsState)) &&
      !dataLoaded.dataFields
    ) {
      const checkDataFileds = !isEqual(prevDataFieldsState, dataFieldsState)
        ? dataFieldsState
        : checkProfileDataFields
      const newArr = this.changeByProp('dataFields', checkDataFileds)
      const updatedArr = this.applyDataFromProfileFilters('dataFields', newArr)
      this.setFilterData('dataFields', updatedArr)
    }

    if (
      !isEmpty(this.state.eventFiltersToShow) &&
      (prevObjStorePsfs !== objStorePsfs ||
        startDate.format('YYYY-MM-DD') !== prevStartDate.format('YYYY-MM-DD') ||
        endDate.format('YYYY-MM-DD') !== prevEndDate.format('YYYY-MM-DD'))
    ) {
      fetchEventDataList({
        psfs: objStorePsfs,
        params: {
          site: activeSite,
          from: startDate.format('YYYY-MM-DD'),
          to: endDate.format('YYYY-MM-DD'),
        },
      })

      if (
        !!objStorePsfs._sort._field &&
        tableData.get('count') > 0 &&
        !isEqual(prevObjStorePsfs._sort, objStorePsfs._sort)
      ) {
        const idsData = this.filtersDataToSave()
        updateProfileLogbookFilters({
          logbook_filters: {
            ...idsData,
          },
        })
      }
    }

    if (!dataLoader && !isLoading && !activeSite && isLoadTable) {
      setLoadTableData(false)
    }
  }

  componentWillUnmount() {
    const { clearMnaStore, clearLogBookStore, activeSite } = this.props
    if (this.state.initialSite !== activeSite) {
      const idsData = this.filtersDataToSave()
      this.props.updateProfileLogbookFilters({
        logbook_filters: {
          ...idsData,
        },
      })
    }
    clearMnaStore()
    clearLogBookStore()
  }

  fetchLocusList() {
    const { activeSite, locusFetchList } = this.props
    const psfs = new Psfs()
    psfs
      .addFilter('active', 1)
      .addFilter('visibleInUi', 1)
      .addFilter('site', activeSite)
      .addFields(['id', 'containerName'])

    locusFetchList({ psfs })
  }

  fetchLocusGroups() {
    const { activeSite, fetchLocusGroupsList } = this.props
    const psfs = new Psfs()
    psfs
      .addFilter('active', 1)
      .addFilter('visibleInUi', 1)
      .addFilter('site', activeSite)

    fetchLocusGroupsList({ psfs })
  }

  applyDataFromProfileFilters(field, arr) {
    const { profileLogbookFilters } = this.state
    let filteredArr = []

    const isDataExist = Object.values(profileLogbookFilters).some(
      item => item && item.length > 0,
    )

    if (isDataExist) {
      filteredArr = arr.map(item => {
        if (item.storeName === field) {
          const filteredData = item.value.filter(elem => {
            if (field === 'dataFields') {
              return (
                profileLogbookFilters[field] &&
                profileLogbookFilters[field].some(
                  dataObj => elem.storeName === dataObj.storeName,
                )
              )
            }

            return (
              profileLogbookFilters[field] &&
              profileLogbookFilters[field].some(id => elem.id === id)
            )
          })

          return {
            ...item,
            value: filteredData,
          }
        }

        return item
      })

      return filteredArr
    }

    return arr
  }

  fetchDataByFilter(data, filterType = 'site') {
    const { filtersArr } = this.state
    const { logbookFilters, siteFetchList, storePsfs, setPsfs } = this.props
    const { searchObj, sortObj, path } = storePsfs
    const psfs = new Psfs(path)
    psfs.filtersObj.clearAll()
    psfs.addPagination(1, 20)

    Object.keys(data).forEach(item => {
      const filterData = filtersArr.find(filter => filter.storeName === item)

      if (data[item] && data[item].length > 0) {
        if (item === 'siteTypes') {
          psfs.addFilter('type', data[item], 'in')
        } else if (item === 'regions') {
          psfs.addFilter('region', data[item], 'in')
        } else if (
          item === 'locuses' &&
          filterData.data.length !== data[item].length
        ) {
          psfs.addFilter('locus', data[item], 'in')
        } else if (
          item === 'locusGroups' &&
          filterData.data.length !== data[item].length
        ) {
          psfs.addFilter('locusGroup', data[item], 'in')
        } else if (item === 'events') {
          psfs.addFilter('event', data[item], 'in')
        } else if (item === 'eventCategories') {
          psfs.addFilter('category', data[item], 'in')
        }
      }
    })

    if (filterType === 'site') {
      psfs
        .addFilter('active', 1)
        .addFilter('visibleInUi', 1)
        .addFields(['id', 'name'])
      siteFetchList({ psfs })
    } else {
      psfs._search = searchObj
      psfs._pagination = new Pagination()
      psfs.addPagination(1, 20)

      if (
        this.state.firstLoad &&
        !!Object.values(logbookFilters.sorting).length
      ) {
        const [[sortField, sortOrder]] = Object.entries(logbookFilters.sorting)
        psfs.sortObj.setSort(sortField, sortOrder)
      } else {
        psfs._sort = sortObj
      }

      setPsfs(psfs)
    }
  }

  getFiltersData(filterType = 'site') {
    const { filtersArr } = this.state

    let data = []
    if (filtersArr && filtersArr.length > 0) {
      data = filtersArr.filter(
        item =>
          item.filterType === filterType && item.storeName !== 'dataFields',
      )
    }

    if (filterType === 'site') {
      this.setState({ siteFiltersToShow: data })
    } else {
      this.setState({ eventFiltersToShow: data })
    }

    return data.reduce((acc, item) => {
      const itemValue = item.value
      const { storeName } = item

      if (itemValue && itemValue.length > 0) {
        const ids = itemValue.map(elem => elem.id)
        acc[storeName] = ids
      }

      return acc
    }, {})
  }

  changeByProp(prop, data) {
    const {
      intl: { formatMessage },
    } = this.props

    return this.state.filtersArr.map(item => {
      if (item.storeName === prop) {
        if (item.storeName === 'locuses') {
          const newData = data.map(elem => ({
            ...elem,
            name: elem.containerName,
          }))

          return {
            ...item,
            data: newData,
            value: newData,
          }
        }

        if (
          item.storeName === 'eventCategories' ||
          item.storeName === 'events'
        ) {
          const newData = data.map(elem => ({
            ...elem,
            name: formatMessage({ id: elem.title }),
          }))

          return {
            ...item,
            data: newData,
            value: newData,
          }
        }

        if (item.storeName === 'dataFields') {
          const newData = item.data.filter(elem =>
            data.some(field => elem.storeName === field.storeName),
          )

          return {
            ...item,
            value: newData,
          }
        }

        return {
          ...item,
          data,
          value: data,
        }
      }

      return item
    })
  }

  addTranslationsToDataFields(formatMessage) {
    return this.state.filtersArr.map(filter => {
      if (filter.storeName === 'dataFields') {
        const updatedData = filter.data.map(elem => ({
          ...elem,
          name: formatMessage(logbookMessages[elem.translateName]),
        }))

        return {
          ...filter,
          data: updatedData,
        }
      }

      return filter
    })
  }

  setFilterData(field, newArrData) {
    this.setState(
      prevState => ({
        dataLoaded: {
          ...prevState.dataLoaded,
          [field]: true,
        },
        filtersArr: newArrData,
      }),
      () => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const updatedArr = this.state.filtersArr.map(item => ({
          ...item,
          value: item.data,
        }))

        this.setState(
          {
            initialData: updatedArr,
          },
          this.showBadge,
        )
      },
    )
  }

  showBadge() {
    const { filtersArr } = this.state
    const filteredArr = filtersArr.filter(
      item => item.storeName !== 'dataFields',
    )
    const showBadge = filteredArr.some(
      ({ value, data }) => value.length !== data.length,
    )

    this.setState({ showBadge })
  }

  renderFilters(type) {
    const { filtersArr, setInitialData } = this.state
    const {
      intl: { formatMessage },
    } = this.props

    return filtersArr.map(
      filterData =>
        filterData.filterType === type && (
          <Grid key={filterData.id} item>
            <FilterComponent
              {...filterData}
              handleFilterChange={this.handleFilterChange}
              formatMessage={formatMessage}
              disableUnderline={false}
              allSelectedExistInList
              setInitialData={setInitialData}
              handleSetInitialData={this.handleSetInitialData}
            />
          </Grid>
        ),
    )
  }

  filtersDataToSave() {
    const { filtersArr, isFiltersOpen } = this.state
    const {
      storePsfs: { sortObj },
      logbookFilters: { densePadding = false },
      activeSite,
    } = this.props

    return filtersArr.reduce((result, item) => {
      const { storeName } = item
      let ids = item.value.map(elem => elem.id)

      if (storeName === 'dataFields') {
        const sortedValuesById = item.value.sort((a, b) => a.id - b.id)
        ids = sortedValuesById
      }

      const sortParams = {
        event_date: 'asc',
      }

      if (sortObj._field) {
        delete sortParams.event_date
        sortParams[sortObj._field] = [sortObj.order]
      }

      /* eslint-disable no-param-reassign */
      result[storeName] = ids
      result.site = activeSite
      result.filterPanelOpen = isFiltersOpen
      result.sorting = { ...sortParams }
      result.densePadding = densePadding
      /* eslint-enable no-param-reassign */

      return result
    }, {})
  }

  handleDateRangeChange = range => {
    if (range) {
      let { startDate, endDate } = range

      if (!moment.isMoment(startDate)) {
        startDate = moment(startDate)
      }

      if (!moment.isMoment(endDate)) {
        endDate = moment(endDate)
      }

      this.props.setActiveDateRange({
        startDate,
        endDate,
      })
    }
  }

  handleSetInitialData = flag => {
    this.setState({ setInitialData: flag })
  }

  handleFilterChange = (value, storeName) => {
    const { filtersArr } = this.state
    const { handleFieldsChange, setDataFields } = this.props
    let idsData
    let updatedInitialfData
    const newArr = filtersArr.map(item => {
      if (item.storeName === storeName) {
        return {
          ...item,
          value,
        }
      }

      return item
    })

    if (storeName === 'dataFields') {
      updatedInitialfData = this.state.initialData.map(item => {
        if (item.storeName === storeName) {
          return {
            ...item,
            value,
          }
        }

        return item
      })

      this.setState({ initialData: updatedInitialfData })
    }

    if (!isEqual(filtersArr, newArr)) {
      this.setState(
        prevState => ({
          filterObj: {
            ...prevState.filterObj,
            [storeName]: value,
          },
          filtersArr: newArr,
        }),
        () => {
          let data
          const idObj = this.state.filtersArr.find(
            item => storeName === item.storeName && item.filterType === 'event',
          )

          if (storeName === 'dataFields') {
            handleFieldsChange(value)
            setDataFields(value)
          }

          if (idObj && Object.keys(idObj).length > 0) {
            data = this.getFiltersData('event')
            this.fetchDataByFilter(data, 'event')
          } else {
            data = this.getFiltersData()
            this.fetchDataByFilter(data, 'site')
          }

          this.showBadge()
          idsData = this.filtersDataToSave()
          this.props.updateProfileLogbookFilters({
            logbook_filters: {
              ...idsData,
            },
          })
        },
      )
    }
  }

  checkChangedFilter(type) {
    return this.state.filtersArr
      .filter(item => item.storeName !== 'dataFields')
      .some(
        ({ value, data, filterType }) =>
          value.length !== data.length && filterType === type,
      )
  }

  resetFilters = () => {
    const { filtersArr } = this.state
    const {
      logbookFilters: { densePadding = false },
      updateProfileLogbookFilters,
    } = this.props
    const isFiltersChanged = filtersArr.some(
      ({ value, data, storeName }) =>
        value.length !== data.length && storeName !== 'dataFields',
    )
    const eventChanged = this.checkChangedFilter('event')

    if (isFiltersChanged) {
      const dataFieldsObj = filtersArr.find(
        item => item.storeName === 'dataFields',
      )
      this.setState(
        prevState => {
          const updatedFiltersArr = prevState.initialData.map(item => {
            if (item.storeName === 'dataFields') {
              return {
                ...item,
                value: dataFieldsObj.value,
              }
            }

            return item
          })

          return {
            filtersArr: updatedFiltersArr,
            setInitialData: true,
          }
        },
        () => {
          if (eventChanged) {
            const eventData = this.getFiltersData('event')
            this.fetchDataByFilter(eventData, 'event')
          }

          this.setState({ showBadge: false })
        },
      )
    }

    const filters = this.setDataFieldsToProfile()
    updateProfileLogbookFilters({
      logbook_filters: {
        ...filters,
        densePadding,
      },
    })
  }

  setDataFieldsToProfile() {
    const filters = { ...PROFILE_LOGBOOK_FILTERS }
    const [dataFieldsObj] = this.state.filtersArr.filter(
      item => item.storeName === 'dataFields',
    )
    filters.dataFields = dataFieldsObj.value

    return filters
  }

  handleClick = () => {
    this.setState(
      prevState => ({
        isFiltersOpen: !prevState.isFiltersOpen,
      }),
      () => {
        this.props.handleFilterOpen(this.state.isFiltersOpen)
      },
    )
  }

  renderCollapseBlock() {
    const { isFiltersOpen } = this.state
    const { storePsfs, setPsfs } = this.props

    return (
      <Collapse in={isFiltersOpen}>
        <Grid container classes={{ root: 'filter-wrap' }}>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item>
                <SearchBlock
                  placeholder="Search"
                  className="logbook-search"
                  storePsfs={storePsfs}
                  setPsfs={setPsfs}
                />
              </Grid>
              {this.renderFilters('event')}
            </Grid>
          </Grid>
        </Grid>
      </Collapse>
    )
  }

  onSiteChange = value => {
    if (value) {
      const { siteList, activeSite, setSiteContext } = this.props

      if (activeSite !== value.index) {
        setSiteContext({ site: siteList.get(value.mapKey).id })
      }
    }
  }

  renderFiltersControls() {
    const { showBadge, isFiltersOpen } = this.state

    return (
      <>
        <Badge variant="dot" invisible={!showBadge}>
          <IconButton
            className={cn('icon-btn', { open: isFiltersOpen })}
            onClick={this.handleClick}>
            <OpenFiltersIcon />
          </IconButton>
        </Badge>
        <IconButton
          className={cn('icon-btn', 'reset-btn', { disabled: !showBadge })}
          onClick={this.resetFilters}
          disabled={!showBadge}>
          <ClearFiltersIcon />
        </IconButton>
      </>
    )
  }

  render() {
    const {
      dataFields,
      activeDateRange,
      hideButton,
      siteList,
      activeSite,
      openEventFormModal,
      formListLoader,
      dataLoader,
      storePsfs,
      intl: { formatMessage },
      licensee: { allowCreateLogbookEventButton, usaDateFormat },
    } = this.props
    const { isDataLoading } = this.state

    if (isDataLoading || formListLoader || dataLoader) {
      return <CircleLoader loading />
    }

    const replacedValues = {
      locus: 'unit',
      locus_group: 'unit_group',
    }

    const fields = [...COMPULSORY_FIELDS, ...dataFields].map(
      ({ storeName }) => {
        if (Object.prototype.hasOwnProperty.call(replacedValues, storeName)) {
          return replacedValues[storeName]
        }

        return storeName
      },
    )

    const params = {
      psfs: storePsfs,
      params: {
        site: activeSite,
        from: activeDateRange.get('startDate').format('YYYY-MM-DD'),
        to: activeDateRange.get('endDate').format('YYYY-MM-DD'),
        fields,
      },
      type: LOGBOOK,
    }

    return (
      <>
        <Grid container spacing={3}>
          <Grid item xs={9}>
            <Grid container spacing={4}>
              {this.renderFilters('site')}
              <Grid item className="avatar-block">
                <SelectList
                  variant="outlined"
                  name="site"
                  label={formatMessage(messages.site_list)}
                  onChange={this.onSiteChange}
                  list={siteList}
                  value={activeSite || this.state.initialSite}
                  map={{
                    index: 'id',
                    text: 'name',
                  }}
                />
              </Grid>
              <Grid item className="date-range-wrap">
                <DateRangeInput
                  dateDisplayFormat={getDateFormat(usaDateFormat)}
                  label={formatMessage(messages.dateRange)}
                  onChange={this.handleDateRangeChange}
                />
              </Grid>
              <Grid item className="controls">
                {this.renderFiltersControls()}
              </Grid>
            </Grid>
          </Grid>
          <Grid item container xs={3} justify="flex-end" alignItems="center">
            <ExportButton params={params} />
            {!hideButton && allowCreateLogbookEventButton && (
              <Button
                className="create-event-btn"
                variant="contained"
                color="primary"
                type="button"
                size="medium"
                onClick={() =>
                  openEventFormModal({ isOpen: true, type: 'create' })
                }>
                {formatMessage(messages.createEvent)}
              </Button>
            )}
          </Grid>
        </Grid>
        {this.renderCollapseBlock()}
      </>
    )
  }
}

export default connect(
  state => ({
    formLists: state.getIn(['logbook', 'formLists']),
    events: state.getIn(['logbook', 'events']),
    storePsfs: state.getIn(['logbook', 'storePsfs']),
    categories: state.getIn(['logbook', 'categories']),
    formListLoader: state.getIn(['logbook', 'formListLoader']),
    siteList: state.getIn(['site', 'listData']),
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    siteTypes: state.getIn(['monitorsAndAlerts', 'siteTypes']),
    activeDateRange: state.getIn(['sensor', 'dateRange']),
    locusGroup: state.getIn(['logbook', 'locusGroupList']),
    locusList: state.getIn(['locus', 'listData']),
    regions: state.getIn(['monitorsAndAlerts', 'regionList']),
    isLoadSiteList: state.getIn(['monitorsAndAlerts', 'isLoadSiteList']),
    dataLoader: state.getIn(['logbook', 'filterDataLoader']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    logbookFilters: state.getIn(['profile', 'profile', 'logbookFilters']),
    tableData: state.getIn(['logbook', 'tableData']),
    lang: state.getIn(['locale', 'lang']),
    storeDataFields: state.getIn(['logbook', 'dataFields']),
    isLoadTable: state.getIn(['logbook', 'isLoadTable']),
  }),
  {
    fetchActiveSitesWithoutSiteType,
    setSiteContext,
    openEventFormModal,
    fetchSiteTypes,
    fetchRegionList,
    siteFetchList,
    setActiveDateRange,
    fetchEventFormList,
    fetchLocusGroupsList,
    locusFetchList,
    fetchEventDataList,
    setPsfs,
    clearLogBookStore,
    clearMnaStore,
    updateProfileLogbookFilters,
    resetData,
    resetEventsData,
    fetchProfile,
    resetSitesData,
    setDataFields,
    setLoadTableData,
    resetTableData,
  },
)(injectIntl(FilterBar))
